import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { Search as DSSearch } from '@saucelabs/ds-inputs';

import actions from '../actions';
import selectors from '../selectors';
import constants from '../constants';

const Search: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const currentSearchQuery = useSelector(selectors.searchQuerySelector);

  const fetchGroupsDebounced = useMemo(() => (
    debounce((searchQuery: string) => {
      void dispatch(actions.fetchGroups({
        searchQuery,
        paginationPage: 1,
      }));
    }, constants.FETCH_GROUPS_SEARCH_DEBOUNCE_THRESHOLD_MS)
  ), [dispatch]);

  return (
    <DSSearch
      data-qa="app-management-groups-search"
      defaultValue={currentSearchQuery}
      onChange={fetchGroupsDebounced}
    />
  );
};

export default Search;
